import { createSelector } from 'reselect'
import { RootState } from 'redux/store'

const selectMouseabilityReference = createSelector(
  (state: RootState) => state.qa.mouseabilityReference,
  (mouseabilityReference: string) => mouseabilityReference
)

export default selectMouseabilityReference
